// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TJSQ","largestCol":"styles_largestCol__1rPar","smallestCol":"styles_smallestCol__1PbDd"};